// extracted by mini-css-extract-plugin
export default {"NavigationHeader":"NavigationHeader_NavigationHeader__sdzvu"};